module.exports = __webpack_public_path__ + "static/sesame-street-00-hero-d09f8c4a0a9fb7dabfb7e1070741b128.jpg";